import {checkTourTimeZones, getAnalytics, importFile} from '../../services/AnalyticsService';

function setAnalyticsDataColour (analyticsData, colours) {
  for (let [index, data] of Object.entries(analyticsData)) {
    if (index < colours.length) {
      data.color = colours[index];
    } else {
      let newColor = generateUniqueColour(colours);
      data.color = newColor;
      colours.push(newColor);
    }
  }
}

function generateUniqueColour (colours) {
  let newColour = '';
  let validAndUnique = false;
  while (validAndUnique === false) {
    newColour = '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
    if (newColour.length === 7) {
      let matched = false;
      for (let colour of colours) {
        if (colour === newColour) {
          matched = true;
        }
      }
      if (!matched) {
        validAndUnique = true;
      }
    }
  }
  return newColour;
}

export default {
  namespaced: true,
  state: {
    analytics: {
      clientId: null,
      tourId: null,
      routeId: null,
      language: null,
      dateRange: 30,
      usage: {
        languages: [],
        languageData: []
      }
    },
    colors: ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00',
      '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#651067', '#329262',
      '#5574a6', '#3b3eac', '#b77322', '#16d620', '#b91383', '#f4359e', '#9c5935', '#a9c413', '#2a778d', '#668d1c',
      '#bea413', '#0c5922', '#743411'],
    fileResults: null,
    invalidTours: null,
    isLoading: false,
    isUploading: false
  },
  getters: {
    analytics: (state) => {
      return state.analytics;
    },
    fileResults: (state) => {
      return state.fileResults;
    },
    getColors: (state) => {
      return state.colors;
    },
    getInvalidTours: (state) => {
      return state.invalidTours;
    },
    isLoading: (state) => {
      return state.isLoading;
    },
    isUploading: (state) => {
      return state.isUploading;
    }
  },
  mutations: {
    setAnalytics (state, data) {
      state.analytics = data;
      if (state.analytics.usage) {
        if (state.analytics.usage.languageData) {
          setAnalyticsDataColour(state.analytics.usage.languageData, state.colors);
        }
        if (state.analytics.usage.topicData) {
          setAnalyticsDataColour(state.analytics.usage.topicData, state.colors);
        }
      }
    },
    setFileResults (state, results) {
      state.fileResults = results;
    },
    setInvalidTours (state, data) {
      state.invalidTours = data;
    },
    setIsLoading (state, toggle) {
      state.isLoading = toggle;
    },
    setIsUploading (state, toggle) {
      state.isUploading = toggle;
    }
  },
  actions: {
    async checkTimeZonesForClient ({commit}, clientId) {
      try {
        let invalidTours = await checkTourTimeZones(clientId);
        commit('setInvalidTours', invalidTours.data);
      } catch (error) {
        console.log(error);
      }
    },
    async getAnalyticsData ({commit, dispatch}, data) {
      commit('setAnalytics', data);
      try {
        dispatch('analytics/isLoadingOn', {}, {root: true});
        await getAnalytics(data);
        // commit('setAnalytics', response.data);
      } catch (error) {
        dispatch('analytics/isLoadingOff', {}, {root: true});
        console.log(error);
        throw (error);
      }
    },
    async importFiles ({commit, dispatch}, postData) {
      try {
        dispatch('analytics/isUploadingOn', {}, {root: true});
        await importFile(postData);
      } catch (error) {
        dispatch('analytics/isUploadingOff', {}, {root: true});
        console.log(error);
        throw (error);
      }
    },
    isLoadingOn ({commit}) {
      commit('setIsLoading', true);
    },
    isLoadingOff ({commit}) {
      commit('setIsLoading', false);
    },
    isUploadingOn ({commit}) {
      commit('setIsUploading', true);
    },
    isUploadingOff ({commit}) {
      commit('setIsUploading', false);
    },
    loadImportResults ({commit}, results) {
      commit('setFileResults', results);
    },
    loadAnalytics ({commit}, results) {
      commit('setAnalytics', results);
    },
    resetAnalytics ({commit}, defaults) {
      commit('setAnalytics', defaults);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/analyticsModule.js